import { config } from 'util/config';
import { httpClient } from "util/Api";
import * as globalFunction from 'util/GlobalFunction';

// 新增预设：打开 JobApprovedDocTemplatePreset section 的表单，并清空/加载可选模版
export function addBySection({ parameter, sectionComponent, pageComponent, sectionName, uie } = {}) {
  sectionComponent.child.map((child, i) => {
    if (child.current != null && child.current?.child.current?.props.sectionName === 'JobApprovedDocTemplatePreset') {
      child.current?.setState({ showModal: true, componentType: 'Create' });

      setTimeout(() => {
        child.current?.customForm.current?.additionalFormRef.current?.child.current?.setState({ defaultSelectedRowKeys: [], jobApprovedDocTemplatePresetContentList: [] });
        child.current?.customForm.current?.additionalFormRef.current?.child.current?.getJobApprovedDocTemplateData();
      }, config.setTimeoutMilliSecond * 10);
    }
  })
}

// 编辑预设：拉取详情，回填表单及已选模版
export function editBySection({ parameter, sectionComponent, pageComponent, sectionName, uie } = {}) {
  sectionComponent.setState({ showModal: true, componentType: 'Edit' });
  setTimeout(() => {
    httpClient
      .get(pageComponent.props.areaName + '/' + sectionName + '/' + parameter.key)
      .then(({ data }) => {
        if (data.result) {
          sectionComponent.customForm.current?.setState({ currentDataKey: data.data.key });

          sectionComponent.customForm.current?.formRef.current?.setFieldsValue(data.data);
          sectionComponent.customForm.current?.setState({ formData: data.data });

          let defaultSelectedRowKeys = [];
          let jobApprovedDocTemplatePresetContentList = [];
          data.data.JobApprovedDocTemplatePresetContentList.map((presetContent, i) => {
            defaultSelectedRowKeys.push(presetContent.JobApprovedDocTemplateId);
            jobApprovedDocTemplatePresetContentList.push(presetContent);
          })

          setTimeout(() => {
            sectionComponent.customForm.current?.additionalFormRef.current?.child.current?.setState({ defaultSelectedRowKeys, jobApprovedDocTemplatePresetContentList });
            sectionComponent.customForm.current?.additionalFormRef.current?.child.current?.getJobApprovedDocTemplateData();
          }, config.setTimeoutMilliSecond * 10);
        } else {
          globalFunction.handleResultError(data, pageComponent);
        }
      })
      .catch(function (error) {
        globalFunction.handleError(error, pageComponent);
      });
  }, config.setTimeoutMilliSecond);
}

// “只显示已选项”切换
export function showSelectedItemsOnlyOnChange({ parameter, sectionComponent, pageComponent, sectionName, uie } = {}) {
  let child = sectionComponent.customForm.current?.additionalFormRef.current?.child.current;
  let filteredData = parameter
    ? child?.state.data.filter((item) => child?.state.jobApprovedDocTemplatePresetContentList.map(item => item.JobApprovedDocTemplateId).includes(item.key))
    : child?.state.data;
  child?.setState({ filteredData });
}
